import React from "react";
import { CCard, CCardBody, CCol, CContainer, CRow } from "@coreui/react";
import PublicHeader from "./PublicHeader";

export default function PublicAuthLayout({
  activeAuthPath,
  eyebrow,
  title,
  description,
  benefits,
  rightPane,
}) {
  return (
    <div className="public-core-page public-core-page--auth">
      <section className="public-core-band public-core-band--auth">
        <PublicHeader mode="auth" activeAuthPath={activeAuthPath} />

        <CContainer fluid className="public-core-container">
          <CRow className="public-core-auth-stage g-4 g-xl-5 align-items-center">
            <CCol xs={12} xl={5} className="public-core-auth-stage__copy">
              <CCard className="public-core-auth-copy-card">
                <CCardBody>
                  <div className="public-core-auth-copy__head">
                    <span className="public-core-eyebrow public-core-eyebrow--soft">{eyebrow}</span>
                    <h1>{title}</h1>
                    <p>{description}</p>
                  </div>

                  <CRow className="g-3 public-core-auth-benefits-grid">
                    {benefits.map((benefit) => (
                      <CCol xs={12} md={6} xl={12} key={benefit.title}>
                        <article className="public-core-auth-benefit">
                          <span className="public-core-auth-benefit__label">{benefit.label}</span>
                          <h3>{benefit.title}</h3>
                          <p>{benefit.text}</p>
                        </article>
                      </CCol>
                    ))}
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol xs={12} xl={7} className="public-core-auth-stage__form">
              {rightPane}
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </div>
  );
}
